const BEACON_PATH = '/performance_beacons';
const TRACKED_PATH_PREFIXES = ['/shows', '/storq_voicetracks'];

let initialized = false;
let studioInitStart = null;
let studioMetricsSent = false;

function trackedPath() {
  const path = window.location.pathname;
  return TRACKED_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

function csrfToken() {
  const tokenElement = document.querySelector('meta[name="csrf-token"]');
  return tokenElement ? tokenElement.content : null;
}

function sourceRequestId() {
  const requestElement = document.querySelector('meta[name="request-id"]');
  return requestElement ? requestElement.content : null;
}

function safeRound(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  return Math.round(Number(value) * 100) / 100;
}

function sendMetric(event, metrics = {}, context = {}) {
  if (!trackedPath()) return;

  const token = csrfToken();
  if (!token) return;

  fetch(BEACON_PATH, {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token
    },
    body: JSON.stringify({
      event,
      path: window.location.pathname,
      source_request_id: sourceRequestId(),
      metrics,
      context
    })
  }).catch(() => {
    // Avoid noisy console logs for telemetry transport failures.
  });
}

function captureNavigationMetrics() {
  if (!trackedPath()) return;

  const navEntry = performance.getEntriesByType('navigation')[0];
  if (navEntry) {
    sendMetric('navigation', {
      dns_ms: safeRound(navEntry.domainLookupEnd - navEntry.domainLookupStart),
      tcp_ms: safeRound(navEntry.connectEnd - navEntry.connectStart),
      tls_ms: safeRound(navEntry.connectEnd - navEntry.secureConnectionStart),
      ttfb_ms: safeRound(navEntry.responseStart - navEntry.requestStart),
      download_ms: safeRound(navEntry.responseEnd - navEntry.responseStart),
      dom_content_loaded_ms: safeRound(navEntry.domContentLoadedEventEnd),
      load_event_ms: safeRound(navEntry.loadEventEnd),
      total_ms: safeRound(navEntry.duration)
    }, {
      type: navEntry.type
    });

    return;
  }

  const timing = performance.timing;
  if (!timing) return;

  sendMetric('navigation_legacy', {
    ttfb_ms: safeRound(timing.responseStart - timing.requestStart),
    dom_content_loaded_ms: safeRound(timing.domContentLoadedEventEnd - timing.navigationStart),
    load_event_ms: safeRound(timing.loadEventEnd - timing.navigationStart)
  });
}

function watchStudioState() {
  if (!trackedPath() || studioMetricsSent) return;
  if (!window.VoicetrackStudio || !studioInitStart) return;

  const maxWaitMs = 30000;
  const checkIntervalMs = 500;
  const startedAt = performance.now();

  const interval = window.setInterval(() => {
    const now = performance.now();

    if (window.VoicetrackStudio.audioLoaded) {
      studioMetricsSent = true;
      window.clearInterval(interval);
      sendMetric('studio_audio_ready', {
        studio_ready_ms: safeRound(now - studioInitStart)
      });
      return;
    }

    if (now - startedAt >= maxWaitMs) {
      window.clearInterval(interval);
      sendMetric('studio_audio_timeout', {
        timeout_ms: maxWaitMs
      });
    }
  }, checkIntervalMs);
}

function setupStudioEventListeners() {
  document.addEventListener('xtracker:studio-init-start', (event) => {
    studioInitStart = safeRound(event.detail?.started_at_ms || performance.now());
    studioMetricsSent = false;

    sendMetric('studio_init_start', {
      started_at_ms: studioInitStart
    });

    watchStudioState();
  });

  document.addEventListener('xtracker:studio-init-complete', (event) => {
    const endedAt = safeRound(event.detail?.ended_at_ms || performance.now());
    const initDuration = studioInitStart ? safeRound(endedAt - studioInitStart) : null;

    studioMetricsSent = true;
    sendMetric('studio_init_complete', {
      init_duration_ms: initDuration,
      ended_at_ms: endedAt,
      outro_duration_s: safeRound(event.detail?.outro_duration_s),
      intro_duration_s: safeRound(event.detail?.intro_duration_s)
    });
  });

  document.addEventListener('xtracker:studio-init-failed', (event) => {
    studioMetricsSent = true;
    sendMetric('studio_init_failed', {
      elapsed_ms: studioInitStart ? safeRound(performance.now() - studioInitStart) : null
    }, {
      error: event.detail?.error || 'unknown'
    });
  });
}

function initializeFrontendPerformanceMonitor() {
  if (initialized) return;
  initialized = true;

  if (!trackedPath()) return;

  setupStudioEventListeners();

  if (document.readyState === 'complete') {
    captureNavigationMetrics();
  } else {
    window.addEventListener('load', captureNavigationMetrics, { once: true });
  }
}

document.addEventListener('DOMContentLoaded', initializeFrontendPerformanceMonitor);
document.addEventListener('turbo:load', initializeFrontendPerformanceMonitor);
